import { render, staticRenderFns } from "./orderAfter.vue?vue&type=template&id=066c768a&scoped=true"
import script from "./orderAfter.vue?vue&type=script&lang=js"
export * from "./orderAfter.vue?vue&type=script&lang=js"
import style0 from "./orderAfter.vue?vue&type=style&index=0&id=066c768a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066c768a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('066c768a')) {
      api.createRecord('066c768a', component.options)
    } else {
      api.reload('066c768a', component.options)
    }
    module.hot.accept("./orderAfter.vue?vue&type=template&id=066c768a&scoped=true", function () {
      api.rerender('066c768a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/component/orderAfter.vue"
export default component.exports